var scrollLinks = [].slice.call(document.querySelectorAll('.scroll-link'));

scrollLinks.forEach(function(scrollLink) {
	scrollLink.addEventListener('click', function(e) {
		if(this.tagName == 'A')
			e.preventDefault();

		scrollToElement(document.querySelector(this.getAttribute('href')));
	});
});

var sectionId = window.location.hash,
	section = sectionId ? document.querySelector(sectionId) : false;

if(section) {
	setTimeout(function() {
		scrollToElement(section);
	}, 300);

	if(section.parentNode.classList.contains('accordion')) {
		setTimeout(function() {
			var button = section.querySelector('button'),
				answer = section.querySelector('.answer');

			Velocity(answer, 'slideDown', {duration: 250});

			button.classList.add('open');

			answer.setAttribute('aria-expanded', 'true');
		}, 1200);
	}
}